import React from "react";
import type { CorrectiveActionPlan } from "../../../../components/RCA/types";

interface RCACorrectiveActionsSectionProps {
  actions: CorrectiveActionPlan[];
  onAdd: () => void;
  onUpdate: (index: number, field: keyof CorrectiveActionPlan, value: any) => void;
  onRemove: (index: number) => void;
  readOnly: boolean;
}

const RCACorrectiveActionsSection: React.FC<RCACorrectiveActionsSectionProps> = ({
  actions,
  onAdd,
  onUpdate,
  onRemove,
  readOnly,
}) => {
  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold">
          K. Corrective Action Plans & Continual Monitoring / Improvement
        </h3>
        {!readOnly && (
          <button
            type="button"
            onClick={onAdd}
            className="px-4 py-2 bg-[#0fa9a6] text-white rounded hover:bg-[#0d8f8c]"
          >
            Add Action Plan
          </button>
        )}
      </div>
      <div className="overflow-x-auto">
        <table className="w-full border-collapse border border-gray-300">
          <thead>
            <tr className="bg-gray-100">
              <th className="border p-2">Sr. No</th>
              <th className="border p-2">Root Cause/Contributing Factor</th>
              <th className="border p-2">Corrective Action</th>
              <th className="border p-2">Responsible Person/Team</th>
              <th className="border p-2">Deadline</th>
              <th className="border p-2">Status</th>
              {!readOnly && <th className="border p-2">Action</th>}
            </tr>
          </thead>
          <tbody>
            {actions.length === 0 ? (
              <tr>
                <td
                  colSpan={readOnly ? 6 : 7}
                  className="border p-4 text-center text-gray-500"
                >
                  No corrective action plans added
                </td>
              </tr>
            ) : (
              actions.map((action, index) => (
                <tr key={index}>
                  <td className="border p-2">{action.srNo}</td>
                  <td className="border p-2">
                    <input
                      type="text"
                      value={action.rootCauseOrContributingFactor}
                      onChange={(e) =>
                        onUpdate(
                          index,
                          "rootCauseOrContributingFactor",
                          e.target.value
                        )
                      }
                      className="w-full p-1 border rounded"
                      readOnly={readOnly}
                    />
                  </td>
                  <td className="border p-2">
                    <textarea
                      value={action.correctiveAction}
                      onChange={(e) =>
                        onUpdate(
                          index,
                          "correctiveAction",
                          e.target.value
                        )
                      }
                      className="w-full p-1 border rounded"
                      rows={2}
                      readOnly={readOnly}
                    />
                  </td>
                  <td className="border p-2">
                    <input
                      type="text"
                      value={action.responsiblePersonOrTeam}
                      onChange={(e) =>
                        onUpdate(
                          index,
                          "responsiblePersonOrTeam",
                          e.target.value
                        )
                      }
                      className="w-full p-1 border rounded"
                      readOnly={readOnly}
                    />
                  </td>
                  <td className="border p-2">
                    <input
                      type="date"
                      value={action.deadline}
                      onChange={(e) =>
                        onUpdate(
                          index,
                          "deadline",
                          e.target.value
                        )
                      }
                      className="w-full p-1 border rounded"
                      readOnly={readOnly}
                    />
                  </td>
                  <td className="border p-2">
                    <select
                      value={action.status}
                      onChange={(e) =>
                        onUpdate(
                          index,
                          "status",
                          e.target.value
                        )
                      }
                      className="w-full p-1 border rounded"
                      disabled={readOnly}
                    >
                      <option value="Pending">Pending</option>
                      <option value="In Progress">In Progress</option>
                      <option value="Completed">Completed</option>
                    </select>
                  </td>
                  {!readOnly && (
                    <td className="border p-2 text-center">
                      <button
                        type="button"
                        onClick={() => onRemove(index)}
                        className="text-red-600 hover:text-red-800"
                      >
                        Remove
                      </button>
                    </td>
                  )}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RCACorrectiveActionsSection;
